'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Headers = require('./Headers');

var _Headers2 = _interopRequireDefault(_Headers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BodylessResponse = function () {
  function BodylessResponse(status, headers, body) {
    (0, _classCallCheck3["default"])(this, BodylessResponse);
    this.status = status;
    this.headers = new _Headers2["default"](headers);
    this._hiddenBodyField = body;
  }

  (0, _createClass3["default"])(BodylessResponse, [{
    key: 'json',
    value: function () {
      var _ref = (0, _asyncToGenerator3["default"])( /*#__PURE__*/_regenerator2["default"].mark(function _callee() {
        return _regenerator2["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof this._hiddenBodyField === 'string')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', JSON.parse(this._hiddenBodyField));

              case 2:
                return _context.abrupt('return', this._hiddenBodyField);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function json() {
        return _ref.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: 'text',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3["default"])( /*#__PURE__*/_regenerator2["default"].mark(function _callee2() {
        return _regenerator2["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', (0, _stringify2["default"])(this._hiddenBodyField));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function text() {
        return _ref2.apply(this, arguments);
      }

      return text;
    }()
  }]);
  return BodylessResponse;
}();

exports["default"] = BodylessResponse;